import { CHANNEL } from '../../../constants/messageTemplateKeys';

export const CREATE_TEMPLATE_BUTTON_VARIANTS = {
  DEFAULT: 'default',
  TEXT_DROPDOWN: 'textDropdown',
};

export const TEXT_TEMPLATE_CREATE_OPTIONS = [
  { key: CHANNEL.MMS, label: 'MMS Template' },
  { key: CHANNEL.SMS, label: 'SMS Template' },
];
